import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Clients.css";
import AOS from "aos";
import "aos/dist/aos.css";

/* Swiper */
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

const clients = [
  { id: 1, name: "Jehangir Hospital, Pune", logo: "/assets/clients/client1.png" },
  { id: 2, name: "Lokmanya Hospital, Pune", logo: "/assets/clients/client2.png" },
  { id: 3, name: "Noble Hospitals, Pune", logo: "/assets/clients/client3.png" },
  { id: 4, name: "Surya Hospital, Dharashiv", logo: "/assets/clients/client4.png" },
  { id: 5, name: "Sahyadri Hospitals, Pune", logo: "/assets/clients/client5.png" },
  { id: 6, name: "Fortis Hospital, Mumbai", logo: "/assets/clients/client6.png" },
  { id: 7, name: "Aryan Heart Care, Miraj", logo: "/assets/clients/client12.png" },
  { id: 8, name: "Lifeline Hospital, Baramati", logo: "/assets/clients/client8.png" },
];

function Clients() {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    AOS.init({ duration: 900, once: true });

    const check = () => setIsMobile(window.innerWidth < 1024);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  return (
    <div className="clients-page">
      <h2 className="clients-title" data-aos="fade-up">
        Trusted by Leading Hospitals
      </h2>

      {/* ✅ MOBILE SLIDER */}
      {isMobile ? (
        <Swiper
          modules={[Autoplay, Pagination]}
          slidesPerView={1.2}
          spaceBetween={15}
          centeredSlides={true}
          autoplay={{ delay: 2500 }}
          pagination={{ clickable: true }}
        >
          {clients.map((client) => (
            <SwiperSlide key={client.id}>
              <div className="client-card mobile">
                <img src={client.logo} alt={client.name} />
                <p>{client.name}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      ) : (
        /* ✅ DESKTOP GRID */
        <div className="clients-grid">
          {clients.map((client, i) => (
            <div
              key={client.id}
              className="client-card"
              data-aos="fade-up"
              data-aos-delay={i * 100}
            >
              <img src={client.logo} alt={client.name} />
              <p>{client.name}</p>
            </div>
          ))}
        </div>
      )}

      {/* BUTTON */}
      <div className="view-all-container">
        <button
          className="view-all-btn"
          onClick={() => navigate("/hospital-ot-projects")}
        >
          View All Projects
        </button>
      </div>
    </div>
  );
}

export default Clients;